


export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE"
export const FILTER = "FILTER"
export const GET_COUNTRIES = "GET_COUNTRIES"
export const GET_COUNTRY = "GET_COUNTRY"
export const GET_ACTIVITIES = "GET_ACTIVITIES"
export const POST_ACTIVITY = "POST_ACTIVITY"

export const SET_CONTINENT_FILTER= "SET_CONTINENT_FILTER"
export const  SET_POPULATION_FILTER = "SET_POPULATION_FILTER"
export const   SET_ALPHABETICAL_FILTER = "SET_ALPHABETICAL_FILTER"
export const   RESET_FILTERS = "RESET_FILTERS"


